import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CustomLayoutComponent} from './core/components/layout/custom-layout/custom-layout.component';
import {ChangePasswordComponent} from "./modules/authentication/change-password/change-password.component";
import {AuthGuard} from "./core/guards/auth.guard";
import {LandingGuard} from "./core/guards/landing.guard";
import {BreadcrumbTranslateService} from "./services/breadcrumb-translate.service";
import {NotFoundComponent} from "./shared/component/not-found/not-found.component";
import {PassedUsersListComponent} from "./modules/passed-users/passed-users-list/passed-users-list.component";
import {UsersResolver} from "./resolvers/users.resolver";
import {PassedUsersResolver} from "./resolvers/passed-users.resolver";

const routes: Routes = [
  {
    path: 'auth',
    canActivate: [LandingGuard],
    loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule),
    data: {}
  },
  {
    path: '',
    component: CustomLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'doors',
        pathMatch: 'full'
      },
      {
        path: 'doors',
        loadChildren: () => import('./modules/doors/doors.module').then(m => m.DoorsModule),
        canActivate: [AuthGuard],
        data: {
          toolbarShadowEnabled: true,
          scrollDisabled: false,
          title: 'Doors',
          breadcrumbs: '{{breadcrumb}}'
        },
        resolve: {
          breadcrumb: BreadcrumbTranslateService
        }
      },
      {
        path: 'challenges',
        loadChildren: () => import('./modules/challenges/challenges.module').then(m => m.ChallengesModule),
        canActivate: [AuthGuard],
        data: {
          toolbarShadowEnabled: true,
          scrollDisabled: false,
          title: 'Challenges',
          breadcrumbs: '{{breadcrumb}}'
        },
        resolve: {
          breadcrumb: BreadcrumbTranslateService
        }
      },
      {
        path: 'questions-banks',
        loadChildren: () => import('./modules/questions-banks/questions-banks.module').then(m => m.QuestionsBanksModule),
        data: {
          toolbarShadowEnabled: true,
          scrollDisabled: false,
          title: 'Questions banks',
          breadcrumbs: '{{breadcrumb}}'
        },
        resolve: {
          breadcrumb: BreadcrumbTranslateService
        }
      },
      {
        path: 'users',
        loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule),
        data: {
          toolbarShadowEnabled: true,
          scrollDisabled: false,
          title: 'Users',
          breadcrumbs: '{{breadcrumb}}'
        },
        resolve: {
          breadcrumb: BreadcrumbTranslateService
        }
      },
      {
        path: 'notifications',
        loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule),
        data: {
          toolbarShadowEnabled: true,
          scrollDisabled: false,
          title: 'Notifications',
          breadcrumbs: '{{breadcrumb}}'
        },
        resolve: {
          breadcrumb: BreadcrumbTranslateService
        }
      },
      {
        path: 'settings',
        loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
        data: {
          toolbarShadowEnabled: true,
          scrollDisabled: false,
          title: 'Settings',
          breadcrumbs: '{{breadcrumb}}'
        },
        resolve: {
          breadcrumb: BreadcrumbTranslateService
        }
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Change password',
        },
        resolve: {}
      },
      {
        path: 'passed-users-list',
        component: PassedUsersListComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Passed users',
        },
        resolve: {
          passed_users: PassedUsersResolver
        }
      },
      {
        path: '404',
        component: NotFoundComponent,
        data: {
          title: '404 not found',
        },
        resolve: {}
      },
      {
        path: '**',
        redirectTo: '404',
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
